"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalObservation = void 0;
class MedicalObservation {
    constructor(props) {
        this.resourceType = props?.resourceType;
        this.bodySite = props?.bodySite;
        this.code = props?.code;
        this.effectiveDateTime = props?.effectiveDateTime;
        this.effectivePeriod = props?.effectivePeriod;
        this.encounter = props?.encounter;
        this.note = props?.note;
        this.status = props?.status;
        this.subjectUid = props?.subjectUid;
        this.valueString = props?.valueString;
        this.valueBoolean = props?.valueBoolean;
        this.valueInteger = props?.valueInteger;
        this.valueRatio = props?.valueRatio;
        this.valueTime = props?.valueTime;
        this.valuePeriod = props?.valuePeriod;
    }
}
exports.MedicalObservation = MedicalObservation;
